import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Upload, message } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import WidgetAjax from '../../widget/WidgetAjax';
import Config from '../../config/Config';
const path =Config.getBasePath();
const ImageUploader = ({
  maxCount = 3,
  maxSize = 5,
  fileType = ['png', 'jpg', 'jpeg'], // 支持的文件类型
  value = [],
  onChange
}) => {
  const [fileList, setFileList] = useState([]);
  const prevValueRef = useRef([]);

  // 将URL转换为文件对象
  const urlToFile = useCallback(async (url, filename) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return new File([blob], filename, { type: blob.type });
    } catch (error) {
      message.error('文件回显失败');
      console.error('URL转文件失败:', error);
      return null;
    }
  }, []);


  // 改进的文件类型校验 - 同时检查文件后缀和MIME类型
  const checkFileType = (file) => {
    // 1. 检查文件后缀
    const nameParts = file.name.split('.');
    if (nameParts.length < 2) return false; // 没有后缀的文件
    const suffix = nameParts.pop().toLowerCase();

    // 2. 检查MIME类型
    const mimeType = file.type.toLowerCase();
    const validMimeTypes = {
      'png': 'image/png',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'gif': 'image/gif' // 仅作为示例，实际根据配置判断
    };

    // 3. 验证：后缀在允许列表中，且MIME类型匹配
    return fileType.includes(suffix) &&
      mimeType === validMimeTypes[suffix];
  };

  // 校验文件大小
  const checkFileSize = (file) => {
    return file.size / 1024 / 1024 <= maxSize;
  };

  // 上传前校验
  const beforeUpload = (file) => {
    // 检查文件类型（详细日志用于调试）
    console.log(`检查文件: ${file.name}, 类型: ${file.type}, 后缀: ${file.name.split('.').pop()?.toLowerCase()}`);

    if (!checkFileType(file)) {
      message.error(`仅支持上传 ${fileType.join(', ')} 格式的图片`);
      throw new Error('文件类型错误');
    }

    if (!checkFileSize(file)) {
      message.error(`文件大小不能超过 ${maxSize}MB`);
      throw new Error('文件大小超限');
    }

    const activeFiles = fileList.filter(f => f.status !== 'removed' && f.status !== 'error');
    if (activeFiles.length >= maxCount) {
      message.error(`最多只能上传 ${maxCount} 张图片`);
      throw new Error('超出最大数量');
    }

    return true;
  };

  // 处理上传变化
  const handleChange = ({ file }) => {

    // 校验文件大小
    if (!checkFileSize(file)) {
      message.error(`文件 "${file.name}" 大小不能超过 ${maxSize}MB`);
      return

    }
    // 校验文件类型
    if (!checkFileType(file)) {
      message.error(`文件 "${file.name}" 仅支持 ${fileType.join(', ')} 格式`);
      return
    }
    // // 校验通过的文件标记为"done"
    // validFiles.push({ ...item, status: 'done' });

    let formData = new FormData();
    formData.append('file', file?.originFileObj);
    WidgetAjax.uploadFile({
      url: path + "/recruitment/attachment_import",
      formData,
      callback: (res) => {
        if (res.status == 0) {
          if(res.result){
            onChange({...file,objId:res.result})
          }
        }
      }
    });
   

    // ;
  };

  const handleRemove = (file) => {
    const newFileList = fileList.map(f =>
      f.uid === file.uid ? { ...f, status: 'removed', removed: true } : f
    );
    handleChange({ fileList: newFileList });
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div className="ant-upload-text">上传</div>
    </div>
  );

  const activeFiles = fileList.filter(f => f.status !== 'removed' && f.status !== 'error');
  return (
    <Upload
      listType="picture-card"
      fileList={[]}
      beforeUpload={beforeUpload}
      onChange={handleChange}
      maxCount={maxCount}
      showUploadList={{
        showRemoveIcon: true,
        removeIcon: <DeleteOutlined />
      }}
    >
      {activeFiles.length < maxCount && uploadButton}
    </Upload>
  );
};

export default ImageUploader;
